import React from 'react';
import classNames from 'classnames';

import Spinner from 'react-bootstrap/Spinner';
import './Button.scss';

const Button = React.forwardRef(({ loading, disabled, as = 'button', children, className, variant, ...props }, ref) => {
  const Component = as;

  return (
    <Component disabled={disabled || loading} className={classNames('__button', {[`__button-${variant}`]: variant, '__button-loading': loading }, className)} {...props} ref={ref}>
      { loading ?
      <>
        <div className='__button-size-preserve'>{ children }</div>
        <div className='__button-spinner'><Spinner as="span" animation="border" size="sm" /></div>
      </>
      : children }
    </Component>
  );
});

export default Button;